import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import {
  getBrowserTimezone,
  toPMIFormatDateWithTime,
} from '../../../../shared/helpers';
import { LogModel } from '../../models';

export interface SharePermissionLogsTableProps {
  logs: LogModel[];
}

const tableColumns = (): SortedColumn[] => [
  {
    name: 'accountUserId',
    title: 'PMI ID',
    cell: (cntx) => <span>{cntx.row.original?.performedBy?.personId}</span>,
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedBy',
    title: 'Name',
    cell: (cntx) => (
      <span data-exclude-lg>{cntx.row.original?.performedBy?.personName}</span>
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'email',
    title: 'Email',
    cell: (cntx) => (
      <span data-exclude-lg>{cntx.row.original?.performedBy?.email}</span>
    ),
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'consent',
    title: 'Consent',
    cell: ({ row }) => {
      const action = row.original.action ?? null;
      const message = action === 'Privacy.ShareOptIn' ? 'Yes' : 'No';
      return <span>{message ?? action}</span>;
    },
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'performedOn',
    title: `Date/Time (${getBrowserTimezone()})`,
    cell: (cntx) => {
      const formattedDate = cntx.row.original?.performedOn
        ? toPMIFormatDateWithTime(cntx.row.original.performedOn)
        : '';
      return (
        <div className={` fw-normal label`} data-testid="data-status">
          {formattedDate}
        </div>
      );
    },
    width: 10,
    sortingEnabled: false,
  },
];

export default function SharePermissionLogsTable({
  logs,
}: SharePermissionLogsTableProps) {
  return (
    <ResponsiveTable data={logs} columns={tableColumns()} onSort={() => {}} />
  );
}
